import FormattedMessage from 'I18n/components/FormattedMessage';
import HR from 'UIComponents/elements/HR';
import UITile from 'UIComponents/tile/UITile';
import ReviewableSetting from 'automation-ui-canvas/containers/review/ReviewableSetting';
import { useQuery } from 'data-fetching-client';
import { GET_WORFKLOW_NOTIFICATIONS_SUBSCRIPTIONS_SETTINGS } from 'automation-ui-canvas/queries/notificationSettingsQueries';
import { subscriptionSettingsRequestToFormAdapter } from 'automation-ui-canvas/containers/settings/WorkflowNotificationSettingsDecorator';
import makeDefaultNotificationConfigsMap from 'automation-ui-canvas/containers/settings/utils/makeDefaultNotificationConfigsMap';
import { useEffect } from 'react';
import TimingReviewableSetting from 'automation-ui-canvas/containers/review/TimingReviewableSetting';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { FETCH_ENROLLMENT_CONVERSION_STATUS } from 'automation-ui-canvas/containers/enrollment-conversion/wireGetEnrollmentConversionTrackingStatus';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { METRICS_LIMITS } from 'automation-ui-canvas/constants/Gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TimingSettingsSection = ({
  flow
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h6",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.settingsStep.setting.timingSettings"
      })
    }), /*#__PURE__*/_jsx(UITile, {
      compact: true,
      children: /*#__PURE__*/_jsx(TimingReviewableSetting, {
        flow: flow
      })
    })]
  });
};
const PerformanceSettingsSection = ({
  flow
}) => {
  var _metricsToggleQueryRe, _metricsToggleQueryRe2, _notificationsQueryRe;
  const isUngatedForMetricsToggle = useIsUngated(METRICS_LIMITS);
  const notificationsQueryResult = useQuery(GET_WORFKLOW_NOTIFICATIONS_SUBSCRIPTIONS_SETTINGS, {
    variables: {
      flowId: flow.flowId
    }
  });
  const metricsToggleQueryResult = useQuery(FETCH_ENROLLMENT_CONVERSION_STATUS, {
    variables: {
      flowId: flow.flowId
    },
    skip: !isUngatedForMetricsToggle,
    fetchPolicy: 'network-only'
  });
  const metricsToggleValue = (_metricsToggleQueryRe = metricsToggleQueryResult === null || metricsToggleQueryResult === void 0 || (_metricsToggleQueryRe2 = metricsToggleQueryResult.data) === null || _metricsToggleQueryRe2 === void 0 || (_metricsToggleQueryRe2 = _metricsToggleQueryRe2.fetchEnrollmentConversionStatus) === null || _metricsToggleQueryRe2 === void 0 ? void 0 : _metricsToggleQueryRe2.conversionReportingEnabled) !== null && _metricsToggleQueryRe !== void 0 ? _metricsToggleQueryRe : false;
  const notifications = (notificationsQueryResult === null || notificationsQueryResult === void 0 || (_notificationsQueryRe = notificationsQueryResult.data) === null || _notificationsQueryRe === void 0 ? void 0 : _notificationsQueryRe.workflowNotificationsSubscriptionsSettings) && subscriptionSettingsRequestToFormAdapter(notificationsQueryResult.data.workflowNotificationsSubscriptionsSettings);
  const issuesNotificationSetting = notifications ? notifications.notificationConfigs.ISSUE_NOTIFICATION : makeDefaultNotificationConfigsMap().ISSUE_NOTIFICATION;
  const digestNotificationSetting = notifications ? notifications.notificationConfigs.ENROLLMENT_DIGEST : makeDefaultNotificationConfigsMap().ENROLLMENT_DIGEST;
  useEffect(() => {
    notificationsQueryResult.refetch().catch(err => {
      console.warn(err);
    });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h6",
      marginBlock: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.settingsStep.setting.performanceSettings"
      })
    }), /*#__PURE__*/_jsxs(UITile, {
      compact: true,
      children: [/*#__PURE__*/_jsx(ReviewableSetting, {
        settingName: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformReview.v2.settingsStep.setting.needsReviewNotification"
        }),
        settingValue: issuesNotificationSetting && issuesNotificationSetting.isEnabled,
        settingSectionId: "performance"
      }), /*#__PURE__*/_jsx(HR, {
        distance: "flush"
      }), /*#__PURE__*/_jsx(ReviewableSetting, {
        settingName: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformReview.v2.settingsStep.setting.thresholdNotification"
        }),
        settingValue: digestNotificationSetting && digestNotificationSetting.isEnabled,
        settingSectionId: "performance",
        description: digestNotificationSetting && digestNotificationSetting.isEnabled ? /*#__PURE__*/_jsx(Text, {
          as: "small",
          display: "block",
          marginBlock: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: digestNotificationSetting.rule.notificationCadence === 'DAILY' ? 'platformReview.v2.settingsStep.setting.thresholdNotificationDaily' : 'platformReview.v2.settingsStep.setting.thresholdNotificationWeekly',
            options: {
              max: digestNotificationSetting.rule.increaseThresholdPercentage,
              min: digestNotificationSetting.rule.decreaseThresholdPercentage
            }
          })
        }) : undefined
      }), isUngatedForMetricsToggle && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HR, {
          distance: "flush"
        }), /*#__PURE__*/_jsx(ReviewableSetting, {
          settingName: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformReview.v2.settingsStep.setting.metricsToggle"
          }),
          settingValue: metricsToggleValue,
          settingSectionId: "performance"
        })]
      })]
    })]
  });
};
const SettingsStep = ({
  flow
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "300",
    marginInline: "200",
    children: [/*#__PURE__*/_jsx(TimingSettingsSection, {
      flow: flow
    }), /*#__PURE__*/_jsx(PerformanceSettingsSection, {
      flow: flow
    })]
  });
};
export default SettingsStep;